/**
 * Varibales App bar Mobile
 */
export const PRINCIPAL = 'MOBILE_APPBAR_PRINCIPAL'
export const NAVIGATION = 'MOBILE_APPBAR_NAVIGATION'
